import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { PopupRequest } from '@azure/msal-browser';
import { Navigate, useLocation } from 'react-router';
import { Button } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import { CSSProperties } from 'react';

const loginRequest: PopupRequest = {
    scopes: ['user.read'],
};

const styles: Record<string, CSSProperties> = {
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    },
    card: {
        background: '#fff',
        padding: '48px',
        borderRadius: '12px',
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
        textAlign: 'center' as const,
        maxWidth: '400px',
        width: '100%',
    },
    title: {
        fontSize: '28px',
        fontWeight: 600,
        marginBottom: '12px',
        color: '#1a1a1a',
    },
    subtitle: {
        fontSize: '16px',
        color: '#666',
        marginBottom: '32px',
    },
};

const SignInPage = () => {
    const isAuthenticated = useIsAuthenticated();
    const location = useLocation();
    const { instance } = useMsal();

    const handleLogin = async () => {
        try {
            await instance.loginPopup(loginRequest);
        } catch (error) {
            console.error('Login failed:', error);
        }
    };

    if (isAuthenticated) {
        return <Navigate to="/admin" state={{ from: location }} replace />;
    }

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h1 style={styles.title}>Welcome Back</h1>
                <p style={styles.subtitle}>Sign in to access your admin dashboard</p>
                <Button
                    type="primary"
                    size="large"
                    icon={<LoginOutlined />}
                    onClick={handleLogin}
                    style={{ width: '100%' }}
                >
                    Sign in with Microsoft
                </Button>
            </div>
        </div>
    );
};

export default SignInPage;
